// Blank lines in the standard editor are empty paragraphs. ProseMirror
// paints them with a trailing break, but getHTML() emits <p></p>, which
// has no height once margin is 0. Keep one <br> in the saved HTML, and
// treat that lone <br> as the placeholder when the HTML is loaded again
// so a round trip does not insert a second blank line.

function declarationMap(style) {
  const map = new Map();
  String(style || '').split(';').forEach(part => {
    const index = part.indexOf(':');
    if (index === -1) return;
    const key = part.slice(0, index).trim().toLowerCase();
    const value = part.slice(index + 1).trim().toLowerCase().replace(/\s+/g, ' ');
    if (key) map.set(key, value);
  });
  return map;
}

function isZeroCss(value) {
  return /^(0|0px|0pt|0em|0%)$/.test(value || '');
}

export function composeBlockStyle(node, noMargin) {
  const attrs = node && node.attrs ? node.attrs : {};
  const existing = attrs.style ? String(attrs.style).trim() : '';
  const declared = declarationMap(existing);
  const extras = [];
  if (noMargin) {
    const marginReady = isZeroCss(declared.get('margin'));
    const padLeftReady = declared.get('padding-left') === '5px';
    const padRightReady = declared.get('padding-right') === '5px';
    if (!(marginReady && padLeftReady && padRightReady)) {
      extras.push('margin: 0; padding-left: 5px; padding-right: 5px');
    }
  }
  const align = attrs.textAlign ? String(attrs.textAlign) : '';
  if (align && declared.get('text-align') !== align.toLowerCase()) {
    extras.push(`text-align: ${align}`);
  }
  const base = extras.length ? existing.replace(/;+\s*$/, '') : existing;
  return [base, ...extras].filter(Boolean).join('; ');
}

export function isPlaceholderBreak(dom) {
  if (!dom || !dom.parentNode) return false;
  const parent = dom.parentNode;
  if (String(parent.nodeName || '').toUpperCase() !== 'P') return false;
  let meaningful = 0;
  let soleBreak = false;
  for (let child = parent.firstChild; child; child = child.nextSibling) {
    if (child.nodeType === 3) {
      const text = String(child.textContent || '').replace(/\u00a0/g, ' ');
      if (text.trim()) meaningful += 1;
      continue;
    }
    if (child.nodeType === 8) continue;
    meaningful += 1;
    if (child === dom && String(child.nodeName || '').toUpperCase() === 'BR') soleBreak = true;
  }
  return meaningful === 1 && soleBreak;
}

export function withVisibleEmptyParagraphs(html) {
  return String(html || '').replace(/<p\b([^>]*)>\s*<\/p>/gi, (match, attrs) => `<p${attrs}><br></p>`);
}

export function withPreservedSpaces(html) {
  return String(html || '').replace(/>([^<]*)</g, (match, text) => {
    if (!/ {2,}/.test(text)) return match;
    return `>${text.replace(/ {2,}/g, run => '&nbsp;'.repeat(run.length))}<`;
  });
}

export function serializeStandardEmailHtml(html) {
  return withPreservedSpaces(withVisibleEmptyParagraphs(html));
}
